import cx from 'classnames';

type Props = {
    title: string;
    active?: boolean;
    submit?: boolean;
    size?: 'default' | 'comfortable';
    className?: string;
    onClick?: () => void;
    disabled?: boolean;
    color?: string;
};

type ButtonStyle = Pick<Props, 'active' | 'size' | 'disabled' | 'color'>;

/** Shared button styling, also used for links that must look like buttons. */
export const buttonClassName = ({
    active,
    size = 'default',
    disabled,
    color = 'woodyBrown',
}: ButtonStyle) => {
    const textColor = color === 'peachOrange' ? 'woodyBrown' : 'white';
    const baseClasses = cx(
        'whitespace-nowrap border-[1px] sm:border-1.6px rounded-full leading-none align-middle transition-all duration-150 focus:outline-none hover:outline-none outline-none',
        size === 'comfortable'
            ? 'min-h-[44px] px-3 py-2 text-base sm:px-4 lg:px-17px lg:text-xl'
            : 'px-2 py-6px text-[12px] md:text-base lg:px-17px lg:text-xl',
    );

    const stateClasses = cx(
        disabled && [
            'border-vanillaWhite',
            'text-mongooseGray',
            'pointer-events-none',
        ],
        active && [`bg-${color}`, `text-${textColor}`, `border-${color}`],
        !active &&
            !disabled && [
                'border-woodyBrown',
                'text-woodyBrown',
                `hover:border-${color}`,
                `hover:text-${textColor}`,
                `hover:bg-${color}`,
            ],
    );

    return cx(baseClasses, stateClasses);
};

export const Button = ({
    title,
    active,
    submit,
    size = 'default',
    className,
    onClick,
    disabled,
    color = 'woodyBrown',
}: Props) => (
    <button
        type={submit ? 'submit' : 'button'}
        onClick={onClick}
        disabled={disabled}
        className={cx(
            buttonClassName({ active, size, disabled, color }),
            className,
        )}
    >
        {title}
    </button>
);
